/// <amd-module name="Traceability/RunView/Common/RunViewCommonBreadCrumbService" />
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { Services, VssService } from "VSS/Platform/Context";
import { onClickFPS } from "VSS/Platform/FPS";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";

export interface ISimpleBreadCrumbItem {
    key: string;
    displayText: string;
    url: string;
}

export class RunViewCommonBreadCrumbService extends VssService implements IBreadcrumbItemService {

    public getBreadcrumbItems(breadcrumbId: string): IReadonlyObservableArray<IBreadcrumbItem> {
        return this.items;
    }

    public setBreadcrumb(...items: ISimpleBreadCrumbItem[]): void {
        this.clearBreadcrumbs();

        const breadcrumbItems: IBreadcrumbItem[] = items.map(item => getBreadcrumbItem(item, (l, e) => this._onFPSClick(l, e)));
        this.items.push(...breadcrumbItems);
    }

    public clearBreadcrumbs(): void {
        this.items.removeAll();
    }

    private _onFPSClick = (link: string, ev?: React.MouseEvent<HTMLElement>) => {
        onClickFPS(this.pageContext, link, true, ev);
    }

    private items: ObservableArray<IBreadcrumbItem> = new ObservableArray<IBreadcrumbItem>();
}

function getBreadcrumbItem(item: ISimpleBreadCrumbItem, onFPSClick: (link: string, ev?: React.MouseEvent<HTMLElement>) => void): IBreadcrumbItem {
    return {
        key: item.key,
        text: item.displayText,
        href: item.url,
        onClick: (ev: React.MouseEvent<HTMLElement>) => {
            onFPSClick(item.url, ev);
        }
    };

}

Services.add("RunViewCommonBreadCrumbService", { serviceFactory: RunViewCommonBreadCrumbService });
